module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"menusError":"Error loading needed data for menus"},"es":{"menusError":"Error cargando datos de los menús"}}')
  delete Component.options._Ctor
}
